<template>
  <div class="fantan-result-history">
    <Row type="flex">
      <Col id="fantan-history-fanone" class="fantan-history-bar">
        1 -
        <span>{{ this.one_percentage }}%</span>
      </Col>
      <Col id="fantan-history-fantwo" class="fantan-history-bar">
        2 -
        <span>{{ this.two_percentage }}%</span>
      </Col>
      <Col id="fantan-history-fanthree" class="fantan-history-bar">
        3 -
        <span>{{ this.three_percentage }}%</span>
      </Col>
      <Col id="fantan-history-fanfour" class="fantan-history-bar">
        4 -
        <span>{{ this.four_percentage }}%</span>
      </Col>
    </Row>
    <Row type="flex" justify="space-around">
      <Col
        class="fantan-history-trend-lot-col"
        v-for="(col, index) in this.newArr"
        :key="index"
      >
        <div
          class="fantan-history-trend-lot-cell"
          :class="cell[3]"
          v-for="(cell, index) in col"
          :key="index"
        >
          <fantan-history-popper
            :game="game"
            :table-name="tableName"
            :cell-data="cell"
            :game-code="gameCode"
            :game-id="gameId"
            >{{ cell[3] }}</fantan-history-popper
          >
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import { TimelineMax } from "gsap";
import FantanHistoryPopper from "../widgets/FantanHistoryPopper";

export default {
  props: ["historicalData", "game", "gameCode", "gameId", "tableName"],
  components: {
    Row,
    Col,
    FantanHistoryPopper,
  },
  data() {
    return {
      tempArr: [],
      newArr: [],
      totalRow: 18,
      one_percentage: 0,
      two_percentage: 0,
      three_percentage: 0,
      four_percentage: 0,
      previousBadgeCount: 0,
    };
  },
  watch: {
    historicalData() {
      this.tempArr = [];
      let tempData = [...this.historicalData];
      let index = 0;
      this.one_percentage = 0;
      this.two_percentage = 0;
      this.three_percentage = 0;
      this.four_percentage = 0;

      for (var i = 0; i < tempData.length; i++) {
        let temp = [];

        if (tempData[i]["fan"] == 1) this.one_percentage++;
        if (tempData[i]["fan"] == 2) this.two_percentage++;
        if (tempData[i]["fan"] == 3) this.three_percentage++;
        if (tempData[i]["fan"] == 4) this.four_percentage++;

        //0-2
        temp.push(tempData[i]["draw_result"]);
        temp.push(tempData[i]["draw_no"], tempData[i]["draw_datetime"]);
        //3-4
        temp.push(tempData[i]["fan"], tempData[i]["oe"]);
        //5-8
        temp.push(tempData[i]["ssh123"], tempData[i]["ssh234"]);
        temp.push(tempData[i]["ssh241"], tempData[i]["ssh341"]);
        //9-12
        temp.push(tempData[i]["kwok12"], tempData[i]["kwok14"]);
        temp.push(tempData[i]["kwok23"], tempData[i]["kwok34"]);
        //13-24
        temp.push(tempData[i]["1NIM2"], tempData[i]["1NIM3"]);
        temp.push(tempData[i]["1NIM4"], tempData[i]["2NIM1"]);
        temp.push(tempData[i]["2NIM3"], tempData[i]["2NIM4"]);
        temp.push(tempData[i]["3NIM1"], tempData[i]["3NIM2"]);
        temp.push(tempData[i]["3NIM4"], tempData[i]["4NIM1"]);
        temp.push(tempData[i]["4NIM2"], tempData[i]["4NIM3"]);
        //25-36
        temp.push(tempData[i]["23NGA1"], tempData[i]["24NGA1"]);
        temp.push(tempData[i]["34NGA1"], tempData[i]["13NGA2"]);
        temp.push(tempData[i]["14NGA2"], tempData[i]["34NGA2"]);
        temp.push(tempData[i]["12NGA3"], tempData[i]["14NGA3"]);
        temp.push(tempData[i]["24NGA3"], tempData[i]["12NGA4"]);
        temp.push(tempData[i]["13NGA4"], tempData[i]["23NGA4"]);

        this.tempArr.push(temp);
      }
      this.tempArr.reverse();

      (index = 3),
        (this.newArr = this.tempArr.reduce((result, data, i, array) => {
          if (
            !array[i - 1] ||
            data[index] !== array[i - 1][index] ||
            result[result.length - 1].length === 5
          )
            result.push([]);
          result[result.length - 1].push(data);
          return result;
        }, []));

      this.newArr.reverse();
      this.newArr.splice(this.totalRow);
      this.newArr.reverse();
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.fantan-history-trend-lot-cell {
  color: #ffffff;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  border-radius: 100px;
  margin-top: 6px;
  cursor: pointer;
  overflow: hidden;
}

.fantan-history-trend-lot-cell.\31 {
  background: #c9c9c9;
}

.fantan-history-trend-lot-cell.\32 {
  background: #16cc86;
}

.fantan-history-trend-lot-cell.\33 {
  background: #f9cb62;
}

.fantan-history-trend-lot-cell.\34 {
  background: #fa4358;
}
</style>

<style lang="scss">
.fantan-history-bar {
  flex: 1;
  color: rgb(0, 0, 0);
  background-color: rgb(239, 242, 248);
  padding: 4px 12px;
  margin: 2px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}
</style>